import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FeatureTagInput, FeatureTagSize } from '../../models/feature-tag-input';

@Component({
  selector: 'app-feature-tag',
  templateUrl: './feature-tag.component.html',
  styleUrls: ['./feature-tag.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureTagComponent implements OnInit {
  @Input() tagType: FeatureTagInput = 'new';
  @Input() translateTagX = -133;
  @Input() translateTagY = -122;
  @Input() tagSize: FeatureTagSize = 'small';
  @Input() isAbsoluteElement = false;
  @Input() blueGradient = false;

  tagText = '';

  ngOnInit(): void {
    this.tagText = this.getTagText();
  }

  getTagText(): string {
    switch (this.tagType) {
      case 'new':
        return 'NEW';
      case 'beta':
        return 'BETA';
      case 'ai':
        return 'AI';
    }
  }
}
